/**
 * Whether the time-entry modal should hydrate Tags/Description from persisted draft.
 * Mirrors the condition previously inlined in App#defaultPageWrapper.
 */
export function shouldRestorePersistedNewEntryFields({
    selectedEntryId,
    isStartTimer,
    showTimeFields,
    defaultTags,
}) {
    return (
        !selectedEntryId &&
        !isStartTimer &&
        showTimeFields &&
        !(defaultTags && defaultTags.length)
    )
}



// WEBPACK FOOTER //
// ./src/util/time_entry_draft_utils.js